import { render, staticRenderFns } from "./dong12.vue?vue&type=template&id=27ddc1c2&"
import script from "./dong12.vue?vue&type=script&lang=js&"
export * from "./dong12.vue?vue&type=script&lang=js&"
import style0 from "./dong12.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports